import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"

const { WithSuspense: CouponsInfo } = lazyloadHelper(
    () => import(/* webpackChunkName: "couponsinfo" */ "../loyalty-club/CouponsInfo"),
)

export { CouponsInfo }
